import { SVGProps } from "react";

interface ArrowUpMobileProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const ArrowUpMobile = ({ color = "#97A0AF", ...props }: ArrowUpMobileProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    style={{ color }}
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 7.1 4.1 11a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.091-.516.275-.7L7.3 5c.1-.1.208-.17.325-.213a1.149 1.149 0 0 1 .75 0A.85.85 0 0 1 8.7 5l4.6 4.6a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L8 7.1Z"
    />
  </svg>
);
export default ArrowUpMobile;
